import moment from "moment";

export default {
  updateLoading(state, payload) {
    state.loading = payload;
  },
  updateData: function (state, payload) {
    state.data = payload;
  },
  updateItem: function (state, payload) {
    Object.assign(state.data, payload);
  },
};
